import LegalPage from "@/pages/LegalPage";
export default function PrivacyPolicy() {
  return <LegalPage tKey="privacy" testId="privacy-page" />;
}
